if (!customElements.get('l-customer-orders')) {
	customElements.define(
		'l-customer-orders',
		class LTAHeaderCustomerOrders extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements
				this.copyOrderIdEls = this.querySelectorAll('[data-copy-order-btn]')

				// Events
				this.setupCopyOrderIdEvent()
			}

			setupCopyOrderIdEvent() {
				this.copyOrderIdEls.forEach((el) => {
					el.addEventListener('click', (e) => {
						e.preventDefault()

						const orderId = el.getAttribute('data-order-id')
						if (orderId) navigator.clipboard.writeText(orderId)

						el.classList.add('is-copied')

						l_debounce(() => {
							el.classList.remove('is-copied')
						}, 2000)()
					})
				})
			}
		}
	)
}

if (!customElements.get('l-customer-returns')) {
	customElements.define(
		'l-customer-returns',
		class LTACustomerReturns extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements
				this.copyContentBtnEls = this.querySelectorAll('[data-copy-content-btn]')
				this.iframeEl = this.querySelector('[data-iframe]')

				this.orderIdFieldEl = this.querySelector('[data-order-id-field]')
				this.orderNumberValueEl = this.querySelector('[data-order-number-value]')
				this.orderCopyBtnEl = this.orderIdFieldEl.querySelector('[data-copy-content-btn]')

				this.zipcodeFieldEl = this.querySelector('[data-zipcode-field]')
				this.zipcodeValueEl = this.querySelector('[data-zipcode-value]')
				this.zipCopyBtnEl = this.zipcodeFieldEl.querySelector('[data-copy-content-btn]')

				console.log(this.orderCopyBtnEl)
				console.log(this.zipCopyBtnEl)

				// Events
				this.setupCopyContent()
				this.setupData()
			}

			setupData() {
				const currentHref = window.location.href
				const url = new URL(currentHref)

				const orderId = url.searchParams.get('order_id')
				const zipCode = url.searchParams.get('zip_code')

				// Handle order ID field
				this.orderIdFieldEl.classList.toggle('l-hidden', !orderId)
				if (orderId) {
					this.orderNumberValueEl.innerHTML = orderId
					this.orderCopyBtnEl.setAttribute('data-content', orderId)
				}

				// Handle zipcode field
				this.zipcodeFieldEl.classList.toggle('l-hidden', !zipCode)
				if (zipCode) {
					this.zipcodeValueEl.innerHTML = zipCode
					this.zipCopyBtnEl.setAttribute('data-content', zipCode)
				}
			}

			setupCopyContent() {
				this.copyContentBtnEls.forEach((el) => {
					el.addEventListener('click', (e) => {
						e.preventDefault()

						const orderId = el.getAttribute('data-content')
						if (orderId) navigator.clipboard.writeText(orderId)

						el.classList.add('is-copied')

						l_debounce(() => {
							el.classList.remove('is-copied')
						}, 2000)()
					})
				})
			}
		}
	)
}

